var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrashDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#4D5154"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9444 44.0026H25.2778C23.278 44.0026 21.6667 42.2838 21.6667 40.1508V24.1508H20.8333C20.3613 24.1508 20 23.7653 20 23.2619V22.373C20 21.8695 20.3613 21.4841 20.8333 21.4841H41.3889C41.8609 21.4841 42.2222 21.8695 42.2222 22.373V23.2619C42.2222 23.7653 41.8609 24.1508 41.3889 24.1508H40.5556V40.1508C40.5556 42.2838 38.9442 44.0026 36.9444 44.0026ZM35 28.2989H33.8889C33.4169 28.2989 33.0556 28.6843 33.0556 29.1878V38.0767C33.0556 38.5801 33.4169 38.9656 33.8889 38.9656H35C35.472 38.9656 35.8333 38.5801 35.8333 38.0767V29.1878C35.8333 28.6843 35.472 28.2989 35 28.2989ZM28.3333 28.2989H27.2222C26.7502 28.2989 26.3889 28.6843 26.3889 29.1878V38.0767C26.3889 38.5801 26.7502 38.9656 27.2222 38.9656H28.3333C28.8053 38.9656 29.1667 38.5801 29.1667 38.0767V29.1878C29.1667 28.6843 28.8053 28.2989 28.3333 28.2989ZM34.1667 20.0026H28.0556C27.5836 20.0026 27.2222 19.6172 27.2222 19.1137V18.2248C27.2222 17.7214 27.5836 17.3359 28.0556 17.3359H34.1667C34.6387 17.3359 35 17.7214 35 18.2248V19.1137C35 19.6172 34.6387 20.0026 34.1667 20.0026Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashDark);
export default __webpack_public_path__ + "static/media/iconTrashDark.3362a4c603507332be869ea526204d8c.svg";
export { ForwardRef as ReactComponent };